import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { Text } from '@mxenabled/mxui'
import { formatCurrency } from '../../../core/utils/NumberFormatting'
type RecurringSettingsProps = {
  amount: number
  bgcolor: string
  isLargeScreen: boolean
  isSmallScreen: boolean
  label: string
}

export const RecurrenceLegend = ({
  amount,
  bgcolor,
  isLargeScreen,
  isSmallScreen,
  label,
}: RecurringSettingsProps) => (
  <Stack sx={{ alignItems: 'center', flexDirection: 'row', gap: 8 }}>
    <Box
      sx={{
        borderRadius: '2px',
        bgcolor,
        height: 8,
        width: 8,
      }}
    />

    <Stack sx={{ alignItems: 'center', flexDirection: 'row', gap: 2 }}>
      {!isSmallScreen && (
        <Text bold={true} variant="caption">
          {formatCurrency(amount, amount === 0 || !isLargeScreen ? '0,0' : '0,0.00')}
        </Text>
      )}
      <Text variant="caption">{label}</Text>
    </Stack>
  </Stack>
)
